import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03347343"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "simple-tour__title" }
const _hoisted_2 = { class: "simple-tour__text" }

import { Ref, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSimpleTour',
  props: {
    title: {},
    text: {},
    buttonText: {}
  },
  emits: ["close"],
  setup(__props: any, { emit }) {




const tourEl: Ref<null | HTMLDivElement> = ref(null);
function closeTour() {
	if (tourEl.value) {
		tourEl.value?.classList.add('closing');
		setTimeout(() => {
			emit('close');
			tourEl.value?.classList.remove('closing');
		}, 2000);
	} else {
		emit('close');
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "tourEl",
    ref: tourEl,
    class: "simple-tour"
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.text), 1),
    _renderSlot(_ctx.$slots, "before-button"),
    _createElementVNode("button", {
      class: "simple-tour__button button button-light button-md",
      type: "button",
      onClick: closeTour
    }, _toDisplayString(_ctx.buttonText ?? 'Далее'), 1),
    _renderSlot(_ctx.$slots, "after-button")
  ], 512))
}
}

})